"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = exports.useSaleorClient = void 0;
const react_1 = __importDefault(require("react"));
const auth_1 = require("../auth");
const context_1 = require("./context");
function useSaleorClient() {
    const saleor = react_1.default.useContext(context_1.SaleorContext);
    if (!saleor) {
        throw new Error("Could not find saleor's apollo client in the context. " +
            "Did you forget to wrap the root component in a <SaleorProvider>?");
    }
    return saleor;
}
exports.useSaleorClient = useSaleorClient;
exports.useAuth = (stateChangeCallback) => {
    const [authenticated, setAuthenticated] = react_1.default.useState(!!auth_1.getAuthToken());
    const eventHandler = () => {
        const newState = !!auth_1.getAuthToken();
        if (stateChangeCallback && authenticated !== newState) {
            stateChangeCallback(newState);
        }
        setAuthenticated(newState);
    };
    react_1.default.useEffect(() => {
        addEventListener("auth", eventHandler);
        return () => {
            removeEventListener("auth", eventHandler);
        };
    }, [authenticated]);
    return { authenticated };
};
//# sourceMappingURL=helpers.js.map